/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { useSelector } from "react-redux";
import { RootState } from "store/types";

import { NodeType } from "config/UtilityTypes";
import { GetSessionListQuery } from "graphql/internal/generated";

export type SessionsCollection = {
  sessions: NodeType<GetSessionListQuery, "staffSessions">[];
  totalCount: number;
  completedCount: number;
};

export default function useActivity(
  showIncompleteSessions: boolean,
  activityObject: SessionsCollection | undefined
) {
  const selfObject = useSelector((state: RootState) => state.selfObject);
  const showTranscription = selfObject.organizationShowTranscription;
  const transcriptionObject = useSelector(
    (state: RootState) => state.transcriptionObject
  );

  const expandedColumnTitleArray = [
    "DATE/TIME",
    "LESSON",
    ...(transcriptionObject ? [] : ["PARTICIPANTS", ""]),
    "LENGTH",
    "VIDEO",
    ...(showTranscription ? ["TRANSCRIPT"] : []),
  ];

  const filteredActivityResults = getSessions(
    activityObject,
    showIncompleteSessions
  );

  return {
    expandedColumnTitleArray,
    filteredActivityResults,
    showTranscript: selfObject.organizationShowTranscription,
  };
}

export function getSessions(
  activityObject: SessionsCollection | undefined,
  showIncompleteSessions: boolean
) {
  if (showIncompleteSessions) return activityObject?.sessions ?? [];
  return activityObject?.sessions.filter((row) => !row.isCancelled) ?? [];
}
